<template>
    <div id="app"
         class="grid">
        <template v-if="isPdf || isLogin">
            <router-view />
        </template>
        <template v-else>
            <TheHeader :hide-items="isHideHeaderItems" />
            <div :class="['grid__wrapper', {'grid_theme_full': isFullWidthContent}]">
                <main class="grid__main">
                    <transition name="fade"
                                mode="out-in">
                        <router-view />
                    </transition>
                </main>
                <TheSidebar
                    v-if="!isHideSidebar"
                    :hide-sidebar-news="isHideSidebarNews" />
            </div>
            <TheFooter />
            <ThePopups ref="popups" />
        </template>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import TheFooter from './sections/TheFooter/TheFooter';
import TheHeader from './sections/TheHeader/TheHeader';
import ThePopups from '@/sections/ThePopups/ThePopups';
import TheSidebar from './sections/TheSidebar/TheSidebar';

export default {
    name: 'App',

    components: {
        TheFooter,
        TheHeader,
        ThePopups,
        TheSidebar
    },

    computed: {
        ...mapGetters({
            complexes      : 'GET_DISTRICT_LIST',
            userDataLoaded : 'GET_IS_USER_DATA_LOADED',
            isAuthenticated: 'GET_IS_AUTHENTICATED'
        }),

        isHideSidebar() {
            return Boolean(this.$route.meta.hideSidebar);
        },

        isHideSidebarNews() {
            return Boolean(this.$route.meta.hideSidebarNews);
        },

        isHideHeaderItems() {
            return Boolean(this.$route.meta.hideHeaderItems);
        },

        isPdf() {
            return this.$route.meta.pdf || false;
        },

        isLogin() {
            return this.$route.meta.login || false;
        },

        isFullWidthContent() {
            return this.$route.meta.fullWidth;
        },

        isRequiresAuth() {
            return Boolean(this.$route.meta.requiresAuth);
        }
    },

    async created() {
        // if (!this.complexes?.length && this.isAuthenticated) {
        //     await this.getComplexes();
        // }

        if (!this.isLogin && !this.isPdf && this.isRequiresAuth && !this.userDataLoaded) {
            await this.getUserData();
        }
    },

    methods: {
        // ...mapActions(['getComplexes', 'getUserData']),
        ...mapActions(['getUserData']),

        showCallbackForm() {
            this.$refs.popups.showCallbackForm();
        },

        hideCallbackForm() {
            this.$refs.popups.hideCallbackForm();
        },

        showUniqueCheckForm() {
            this.$refs.popups.showUniqueCheckForm();
        },

        hideUniqueCheckForm() {
            this.$refs.popups.hideUniqueCheckForm();
        },

        showRequestBrokerTourForm() {
            this.$refs.popups.showRequestBrokerTourForm();
        },

        hideRequestBrokerTourForm() {
            this.$refs.popups.hideRequestBrokerTourForm();
        },

        showInformationForClient() {
            this.$refs.popups.showInformationForClient();
        },

        hideInformationForClient() {
            this.$refs.popups.hideInformationForClient();
        }
    },

    provide() {
        return {
            showCallbackForm         : this.showCallbackForm,
            hideCallbackForm         : this.hideCallbackForm,
            showUniqueCheckForm      : this.showUniqueCheckForm,
            hideUniqueCheckForm      : this.hideUniqueCheckForm,
            showRequestBrokerTourForm: this.showRequestBrokerTourForm,
            hideRequestBrokerTourForm: this.hideRequestBrokerTourForm,
            showInformationForClient : this.showInformationForClient,
            hideInformationForClient : this.hideInformationForClient
        };
    }
};
</script>

<style lang="scss">
@import "./styles/common/app";
</style>
